import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Array$from from 'babel-runtime/core-js/array/from';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { checkCreativePlan, saveCreativePlan } from '@/api/creative/report';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formValue: {
      type: Object,
      require: true
    }
  },
  data: function data() {
    return {
      advName: '',
      loading: false,
      planedVisible: false,
      planedLoading: false
    };
  },

  methods: {
    editParams: function editParams() {
      var params = {
        adv_names: this.formValue.adv_names.split(','),
        app_tags: this.formValue.app_tags.map(String),
        creative_types: this.formValue.creative_types === '全部' ? [] : this.formValue.creative_types.split(','),
        project_tags: this.formValue.project_tags.map(String),
        start_time: new Date(this.formValue.start_time).getTime() / 1000,
        end_time: this.formValue.end_time === 0 ? 0 : new Date(this.formValue.end_time).getTime() / 1000
      };

      return params;
    },
    handleClose: function handleClose() {
      if (!this.loading) {
        this.$emit('update:visible', false);
      }
    },
    handlePlanedClose: function handlePlanedClose() {
      if (!this.planedLoading) {
        this.planedVisible = false;
      }
    },
    handleReturnEdit: function handleReturnEdit() {
      if (!this.planedLoading) {
        this.planedVisible = false;
        this.handleClose();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var params, res, data, _data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                params = _this.editParams();
                _context.prev = 2;
                _context.next = 5;
                return checkCreativePlan({ adv_names: params.adv_names });

              case 5:
                res = _context.sent;

                if (!(res.data.data && res.data.data.length)) {
                  _context.next = 19;
                  break;
                }

                _this.advName = _Array$from(res.data.data.filter(function (item) {
                  return item.active;
                }), function (_ref) {
                  var adv_name = _ref.adv_name;
                  return adv_name;
                }).join();

                if (!_this.advName) {
                  _context.next = 12;
                  break;
                }

                _this.planedVisible = true;
                _context.next = 16;
                break;

              case 12:
                _context.next = 14;
                return saveCreativePlan(params);

              case 14:
                data = _context.sent;


                if (data.data.code === 0) {
                  _this.$message.success('计划已成功提交');
                  _this.loading = false;
                  _this.handleClose();
                  _this.$emit('handleRefresh');
                }

              case 16:
                _this.loading = false;
                _context.next = 23;
                break;

              case 19:
                _context.next = 21;
                return saveCreativePlan(params);

              case 21:
                _data = _context.sent;


                if (_data.data.code === 0) {
                  _this.$message.success('计划已成功提交');
                  _this.loading = false;
                  _this.handleClose();
                  _this.$emit('handleRefresh');
                }

              case 23:
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context['catch'](2);

                _this.loading = false;

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 25]]);
      }))();
    },
    handlePlanedSubmit: function handlePlanedSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.planedLoading = true;
                params = _this2.editParams();
                _context2.prev = 2;
                _context2.next = 5;
                return saveCreativePlan(params);

              case 5:
                data = _context2.sent;

                if (data.data.code === 0) {
                  _this2.planedLoading = false;
                  _this2.$message.success('计划已成功提交');
                  _this2.handleReturnEdit();
                  _this2.$emit('handleRefresh');
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                _this2.planedLoading = false;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 9]]);
      }))();
    }
  }
};